var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHipFinanceModuleColoured(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HIP Assist Module copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4996 22.624C15.3956 21.656 16.6796 21.052 18.0996 21.052C19.5196 21.052 20.7996 21.656 21.6996 22.624C21.9436 22.884 22.1556 23.172 22.3356 23.48C23.2316 24.448 24.5156 25.052 25.9356 25.052C28.6476 25.052 30.8476 22.848 30.8476 20.136C30.8476 17.424 28.6476 15.22 25.9356 15.22C24.5116 15.22 23.2316 15.824 22.3356 16.792C22.1556 17.1 21.9396 17.388 21.6996 17.648C20.8036 18.616 19.5236 19.22 18.0996 19.22C16.6756 19.22 15.3956 18.616 14.4996 17.648C14.2556 17.388 14.0436 17.1 13.8636 16.792C12.9676 15.824 11.6836 15.22 10.2636 15.22C7.55156 15.22 5.35156 17.42 5.35156 20.136C5.35156 22.852 7.55156 25.052 10.2636 25.052C11.6876 25.052 12.9676 24.448 13.8636 23.48C14.0436 23.172 14.2596 22.884 14.4996 22.624Z",
    fill: "#00BEEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6839 11.7759C21.6839 13.6679 20.1519 15.2039 18.2599 15.2039C16.3679 15.2039 14.8359 13.6679 14.8359 11.7759C14.8359 9.8839 16.3679 8.3479 18.2599 8.3479C20.1519 8.3479 21.6839 9.8839 21.6839 11.7759Z",
    fill: "#00BEEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6839 20.176C21.6839 22.068 20.1519 23.604 18.2599 23.604C16.3679 23.604 14.8359 22.068 14.8359 20.176C14.8359 18.284 16.3679 16.748 18.2599 16.748C20.1519 16.748 21.6839 18.284 21.6839 20.176Z",
    fill: "#00BEEA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHipFinanceModuleColoured);
export default __webpack_public_path__ + "static/media/HIP Finance Module Coloured.cee2f3dfe04547ca75c65a91c49c4303.svg";
export { ForwardRef as ReactComponent };